import React from 'react';
import MaskedInput from 'react-text-mask';

const MonthYearWidget = ({ id, name, placeholder, autofocus, value, required, disabled, onChange }) => {
  return (
    <MaskedInput
      mask={[/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      className="form-control"
      id={id}
      name={name}
      placeholder={placeholder}
      autofocus={autofocus}
      defaultValue={value}
      required={required}
      disabled={disabled}
      onChange={event => onChange(event.target.value)}
    />
  );
};

export default MonthYearWidget;
